import '../../../../es/style/index.less';
import '../../../../es/collapse/style';
import '../../../../es/tag/style';
import './index.less';
// style dependencies
import '../../form/style';
import '../../button/style';
import '../../radio/style';
import '../../check-box/style';
import '../../text-field/style';
import '../../select/style';
import '../../select-box/style';
import '../../switch/style';
import '../../spin/style';
import '../../modal-container/style';
import '../../tooltip/style';
import '../../menu/style';
import '../../dropdown/style';
